import './styles/css/index.css';
import axios, {AxiosResponse} from 'axios';
import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {AppState, Vehicle, Camera} from './types';
import {setVehicles} from './actions';
import LoadingComponent from './components/LoadingComponent';
import LeftPanel from './components/LeftPanel';
import CastingLayout from './components/CastingLayout';
import LocalizationMisc from "./miscs/LocalizationMisc";

const App = () => {
  const state = useSelector( (state: AppState) => state );
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  })
  const {isLoaded, vehicles, cameras, selected, viewMode, leftPanelCollapsed, searchValue} = state;
  const dispatcher = useDispatch();
  const {jwt} = JSON.parse(localStorage.getItem('credentials') || '');
  useEffect( () => {
    if ( !isLoaded ) {
      axios.get('/vehicles', {headers: {authorization: `JWT ${jwt}`}})
      .then( (response: AxiosResponse) => {
        const vehicles: Vehicle[] = response.data.vehicles;
        let cameras: Camera[] = [];
        for ( let i = 0, len = vehicles.length; i < len; i++ ) {
          cameras = cameras.concat( vehicles[i].cams );
        }
        dispatcher(setVehicles({vehicles, cameras}));
      });
      window.addEventListener('resize', () => {
        setDimensions({
          width: window.innerWidth,
          height: window.innerHeight
        });
      });
    }
  });

  return (<div className='App'>
    {!isLoaded && (
      <LoadingComponent />
    )}
    {isLoaded && (
      <div className={`App-loaded row ${leftPanelCollapsed ? 'full-screen' : ''}`}>
        {!leftPanelCollapsed && (<div className='col'><LeftPanel
            vehicles={vehicles}
            cameras={cameras}
            selected={selected}
            viewMode={viewMode}
            searchValue={searchValue}
          />
        </div>)}
        <div className='col' style={{
          width: dimensions.width - ( !leftPanelCollapsed ? 260 : 0 ),
        }}>
          <section className='App-body'>
            <div className='top-bar'>
              <span style={{
                lineHeight: '4vh',
                paddingLeft: '10px',
                verticalAlign: 'middle',
                color: 'white'
              }}>{LocalizationMisc.local('service.name')}</span>
              <a href="https://doc.omnicomm.ru/"><i className="icon icon-help"/></a>
            </div>
            <CastingLayout
              width={ dimensions.width - ( !leftPanelCollapsed ? 260 : 0 ) }
              height={ dimensions.height - 36 }
              selected={selected}
              vehicles={vehicles}
            />
          </section>
        </div>
      </div>
    )}
  </div>);
}

export default App;
